import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "row g-3" }
const _hoisted_2 = { class: "row col-md-7" }
const _hoisted_3 = { class: "el-input-group" }
const _hoisted_4 = { class: "col-md-9" }
const _hoisted_5 = { class: "input-group" }
const _hoisted_6 = { class: "row col-md-7" }
const _hoisted_7 = { class: "el-input-group" }
const _hoisted_8 = { class: "col-md-9" }
const _hoisted_9 = { class: "input-group" }
const _hoisted_10 = { class: "row col-md-7" }
const _hoisted_11 = { class: "el-input-group" }
const _hoisted_12 = { class: "col-md-9" }
const _hoisted_13 = { class: "input-group" }
const _hoisted_14 = { class: "row col-md-7" }
const _hoisted_15 = { class: "el-input-group" }
const _hoisted_16 = { class: "col-md-9" }
const _hoisted_17 = { class: "input-group" }
const _hoisted_18 = { class: "row col-md-7" }
const _hoisted_19 = { class: "el-input-group" }
const _hoisted_20 = { class: "col-md-9" }
const _hoisted_21 = { class: "input-group" }
const _hoisted_22 = { class: "row col-md-7" }
const _hoisted_23 = { class: "el-input-group" }
const _hoisted_24 = { class: "col-md-9" }
const _hoisted_25 = { class: "input-group" }
const _hoisted_26 = { class: "row col-md-7" }
const _hoisted_27 = { class: "el-input-group" }
const _hoisted_28 = { class: "col-md-9" }
const _hoisted_29 = { class: "input-group" }
const _hoisted_30 = { class: "row col-md-7" }
const _hoisted_31 = { class: "el-input-group" }
const _hoisted_32 = {
  key: 0,
  class: "modal"
}
const _hoisted_33 = { class: "modal-content" }
const _hoisted_34 = { class: "form-group" }
const _hoisted_35 = { class: "form-group" }
const _hoisted_36 = { class: "form-group" }
const _hoisted_37 = { class: "form-group" }
const _hoisted_38 = ["disabled"]
const _hoisted_39 = { class: "reports-table" }
const _hoisted_40 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_multiselect = _resolveComponent("multiselect")!
  const _component_b_pagination = _resolveComponent("b-pagination")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[31] || (_cache[31] = _createElementVNode("h1", null, "Отчеты", -1)),
    _createElementVNode("button", {
      class: "open-modal-btn",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openModal && _ctx.openModal(...args)))
    }, "Выгрузить сводный отчет по ДО"),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[18] || (_cache[18] = _createElementVNode("label", {
            for: "katoCode",
            class: "form-label col-md-3"
          }, "Населенный пункт", -1)),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_multiselect, {
                modelValue: _ctx.searchParams.katoCode,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchParams.katoCode) = $event)),
                options: _ctx.katoList,
                searchable: true,
                closeOnSelect: true,
                "custom-label": _ctx.formattedKatoLabel,
                placeholder: "Выберите Като",
                multiple: false,
                "clear-on-select": true
              }, null, 8, ["modelValue", "options", "custom-label"])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _cache[19] || (_cache[19] = _createElementVNode("label", {
            for: "bin",
            class: "form-label col-md-3"
          }, "БИН", -1)),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _withDirectives(_createElementVNode("input", {
                type: "number",
                class: "form-control",
                id: "bin",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchParams.bin) = $event))
              }, null, 512), [
                [_vModelText, _ctx.searchParams.bin]
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _cache[20] || (_cache[20] = _createElementVNode("label", {
            for: "lmsId",
            class: "form-label col-md-3"
          }, "LMS ID", -1)),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                id: "lmsId",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchParams.lmsId) = $event))
              }, null, 512), [
                [_vModelText, _ctx.searchParams.lmsId]
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _cache[21] || (_cache[21] = _createElementVNode("label", {
            for: "accountingMonth",
            class: "form-label col-md-3"
          }, "Расчетный месяц", -1)),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _withDirectives(_createElementVNode("input", {
                type: "number",
                max: "12",
                class: "form-control",
                id: "accountingMonth",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searchParams.accountingMonth) = $event))
              }, null, 512), [
                [_vModelText, _ctx.searchParams.accountingMonth]
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _cache[22] || (_cache[22] = _createElementVNode("label", {
            for: "accountingYear",
            class: "form-label col-md-3"
          }, "Расчетный год", -1)),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _withDirectives(_createElementVNode("input", {
                type: "number",
                min: "2024",
                class: "form-control",
                id: "accountingYear",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.searchParams.accountingYear) = $event))
              }, null, 512), [
                [_vModelText, _ctx.searchParams.accountingYear]
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _cache[23] || (_cache[23] = _createElementVNode("label", {
            for: "dateTo",
            class: "form-label col-md-3"
          }, "Дата выгрузки отчета с:", -1)),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _withDirectives(_createElementVNode("input", {
                type: "date",
                class: "form-control",
                id: "dateTo",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.searchParams.reportDateFrom) = $event))
              }, null, 512), [
                [_vModelText, _ctx.searchParams.reportDateFrom]
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, [
          _cache[24] || (_cache[24] = _createElementVNode("label", {
            for: "dateFrom",
            class: "form-label col-md-3"
          }, "Дата выгрузки отчета до:", -1)),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _withDirectives(_createElementVNode("input", {
                type: "date",
                class: "form-control",
                id: "dateFrom",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.searchParams.reportDateTo) = $event))
              }, null, 512), [
                [_vModelText, _ctx.searchParams.reportDateTo]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("button", {
              class: "btn btn-primary",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.fetchReports(true)))
            }, "Поиск"),
            _createElementVNode("button", {
              class: "btn btn-warning",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.clearSearchParam()))
            }, "Сбросить фильтр")
          ])
        ])
      ])
    ]),
    _createVNode(_component_b_pagination, {
      modelValue: _ctx.currentPage,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.currentPage) = $event)),
      "total-rows": _ctx.pageResponse?.totalElements,
      "per-page": _ctx.searchParams.pageSize
    }, null, 8, ["modelValue", "total-rows", "per-page"]),
    (_ctx.showModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _cache[29] || (_cache[29] = _createElementVNode("h2", null, "Выберите месяц и год", -1)),
            _createElementVNode("form", {
              onSubmit: _cache[16] || (_cache[16] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_34, [
                _cache[25] || (_cache[25] = _createElementVNode("label", { for: "accountingMonth" }, "БИН:", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "bin",
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.bin) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.bin]
                ])
              ]),
              _createElementVNode("div", _hoisted_35, [
                _cache[26] || (_cache[26] = _createElementVNode("label", { for: "accountingMonth" }, "LMS ID:", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "bin",
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.lmsId) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.lmsId]
                ])
              ]),
              _createVNode(_component_multiselect, {
                modelValue: _ctx.kato,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.kato) = $event)),
                options: _ctx.katoList,
                searchable: true,
                closeOnSelect: true,
                "custom-label": _ctx.formattedKatoLabel,
                placeholder: "Выберите Като",
                multiple: false,
                "clear-on-select": true
              }, null, 8, ["modelValue", "options", "custom-label"]),
              _createElementVNode("div", _hoisted_36, [
                _cache[27] || (_cache[27] = _createElementVNode("label", { for: "accountingMonth" }, "Месяц:", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  id: "accountingMonth",
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.accountingMonth) = $event)),
                  min: "1",
                  max: "12",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.accountingMonth]
                ])
              ]),
              _createElementVNode("div", _hoisted_37, [
                _cache[28] || (_cache[28] = _createElementVNode("label", { for: "accountingYear" }, "Год:", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  id: "accountingYear",
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.accountingYear) = $event)),
                  min: "2000",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.accountingYear]
                ])
              ]),
              _createElementVNode("button", {
                type: "submit",
                class: "submit-btn",
                disabled: _ctx.isLoading
              }, _toDisplayString(_ctx.isLoading ? 'Выгружается...' : 'Выгрузить'), 9, _hoisted_38)
            ], 32),
            _createElementVNode("button", {
              class: "close-modal-btn",
              onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
            }, "Закрыть")
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("table", _hoisted_39, [
      _cache[30] || (_cache[30] = _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("th", null, "Имя файла"),
          _createElementVNode("th", null, "БИН"),
          _createElementVNode("th", null, "LMS ID"),
          _createElementVNode("th", null, "Расчетный месяц и год"),
          _createElementVNode("th", null, "Населенный пункт"),
          _createElementVNode("th", null, "Статус")
        ])
      ], -1)),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reports, (report, index) => {
          return (_openBlock(), _createElementBlock("tr", { key: index }, [
            _createElementVNode("td", null, [
              (report.reportStatus === 'GENERATED')
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    onClick: ($event: any) => (_ctx.handleDownload(report.uuid, report.fileName)),
                    class: _normalizeClass({ 'active-link': report.reportStatus === 'GENERATED', 'error-link': report.reportStatus === 'ERROR' })
                  }, _toDisplayString(report.fileName), 11, _hoisted_40))
                : (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    class: _normalizeClass({ 'inactive-link': report.reportStatus !== 'GENERATED', 'error-link': report.reportStatus === 'ERROR' })
                  }, _toDisplayString(report.fileName), 3))
            ]),
            _createElementVNode("td", null, _toDisplayString(report.bin), 1),
            _createElementVNode("td", null, _toDisplayString(report.lmsId), 1),
            _createElementVNode("td", null, _toDisplayString(report.accountingMonth) + "." + _toDisplayString(report.accountingYear), 1),
            _createElementVNode("td", null, _toDisplayString(_ctx.getKatoName(report.katoCode).nameRu), 1),
            _createElementVNode("td", {
              class: _normalizeClass(_ctx.getStatusClass(report.reportStatus))
            }, _toDisplayString(_ctx.translateStatus(report.reportStatus)), 3)
          ]))
        }), 128))
      ])
    ])
  ]))
}